/**
 * Account API module — dev-only account reset.
 */
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { MUTATION_TIMEOUT_MS } from './requestTimeout';
import type { AccountDeletionFeedback } from '@overlayqa/shared';

log.info('[api/account] Module loaded');

export interface AccountResetResponse {
  success: boolean;
}

export interface AccountDeleteResponse {
  deleted: boolean;
}

export const accountApi = {
  /**
   * Dev-only: wipes all of the current user's data (projects, issues, teams,
   * integrations) and re-bootstraps a fresh account with onboardingCompleted
   * reset to false. The server endpoint 403s outside local development.
   */
  reset: (token: string | undefined) =>
    fetchApi<AccountResetResponse>('/account/reset', {
      token,
      method: 'POST',
      timeoutMs: MUTATION_TIMEOUT_MS,
    }),

  /**
   * Permanently delete the caller's own account. Deletes server-side via the
   * Clerk Backend API, which needs no client reverification — Clerk's built-in
   * delete demands a password / email code / phone code, which 87% of our
   * users (Google OAuth signups) do not have.
   */
  deleteAccount: (token: string | undefined, confirmation: string, feedback: AccountDeletionFeedback) =>
    fetchApi<AccountDeleteResponse>('/account/delete', {
      token,
      method: 'POST',
      timeoutMs: MUTATION_TIMEOUT_MS,
      body: JSON.stringify({ confirmation, ...feedback }),
    }),
};
